<template>
  <ItemsQuestion
    ref="child"
    v-on:answerUpdated="onAnswerUpdated"
    :question="questionWithFilteredItemRows"
    :answer="answer"
    :isDisabled="isDisabled"
    :key="childKey"
  ></ItemsQuestion>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import ParkPrograms from '@/services/park_programs'
  import ItemsQuestion from './ItemsQuestion'

  export default {
    name: 'OwnRevenuesQuestion',
    components: {ItemsQuestion},
    props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
    data () {
      return {
        dependenciesByItemRowUuid: {
          '633a8b2d-ca75-4ce1-a52d-7471f0ad59c0': ParkPrograms.ACCELERATION,
          '34f8cee1-b731-4c54-84e5-a792c49d71c8': ParkPrograms.ASSOCIATION,
          '5c7c7940-fedd-474c-9f08-a59fc87b7d06': ParkPrograms.COWORKING,
          '577c92c3-da33-4f47-9961-b6cefdf07e5d': ParkPrograms.INCUBATION,
          '010bdcd0-c214-45a8-a6aa-30a91080b238': ParkPrograms.RESIDENCY
        },
        childKey: Math.floor(Math.random() * 999)
      }
    },
    computed: {
      questionWithFilteredItemRows () {
        const questionWithFilteredItemRows = cloneDeep(this.question)

        questionWithFilteredItemRows.itemsRows = questionWithFilteredItemRows.itemsRows.filter((itemRow) => {
          const { itemRowUuid } = itemRow
          return !this.dependenciesByItemRowUuid.hasOwnProperty(itemRowUuid) ||
            ParkPrograms.has(this.dependenciesByItemRowUuid[itemRowUuid], this.quizAnswers)
        })

        return this.sortItemRowsByRenderingOrder(questionWithFilteredItemRows)
      }
    },
    methods: {
      onAnswerUpdated (answer) {
        this.$emit('answerUpdated', answer)
      },
      sortItemRowsByRenderingOrder (question) {
        question.itemsRows.sort((a, b) => a.renderingOrder - b.renderingOrder)
        return question
      },
      isValid () {
        return this.$refs.child.isValid()
      },
      updateAnswerWhenParkProgramsChange () {
        if (!this.answer || !this.answer.value) {
          return
        }

        const updatedAnswer = this.answerHavingOnlyItemRowsAvailableToAnswer(
          this.answer,
          this.questionWithFilteredItemRows.itemsRows
        )
        this.$emit('answerUpdated', updatedAnswer)
      },
      answerHavingOnlyItemRowsAvailableToAnswer (answer, availableItemsRows) {
        const filteredAnswerValue = answer.value.filter((answerItemRow) => {
          return availableItemsRows.find((itemRow) => itemRow.itemRowUuid === answerItemRow.itemRowUuid)
        })

        return {...answer, value: filteredAnswerValue}
      },
      forceChildRerender () {
        this.childKey += 1
      }
    },
    watch: {
      questionWithFilteredItemRows: {
        immediate: true,
        handler () {
          this.updateAnswerWhenParkProgramsChange()
          this.forceChildRerender()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// OwnRevenuesQuestion.vue?a9f482ba